import { createWalletClient, custom, getAddress, type Address } from "viem";
import { base, mainnet } from "viem/chains";

export async function connectInjectedWallet(): Promise<Address> {
  if (!window.ethereum) throw new Error("Open MetaMask, Rabby, or Ledger Live with your Ledger account connected.");
  const accounts = (await window.ethereum.request({ method: "eth_requestAccounts" })) as string[];
  if (!accounts[0]) throw new Error("No wallet account was returned.");
  return getAddress(accounts[0]);
}

export function baseWallet(account: Address) {
  if (!window.ethereum) throw new Error("No wallet detected.");
  return createWalletClient({ account, chain: base, transport: custom(window.ethereum) });
}

export function ethereumWallet(account: Address) {
  if (!window.ethereum) throw new Error("No wallet detected.");
  return createWalletClient({ account, chain: mainnet, transport: custom(window.ethereum) });
}

export async function switchToBase() {
  if (!window.ethereum) throw new Error("No wallet detected.");
  try {
    await window.ethereum.request({ method: "wallet_switchEthereumChain", params: [{ chainId: "0x2105" }] });
  } catch (error) {
    if ((error as { code?: number }).code !== 4902) throw error;
    await window.ethereum.request({
      method: "wallet_addEthereumChain",
      params: [{
        chainId: "0x2105",
        chainName: "Base",
        nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
        rpcUrls: ["https://mainnet.base.org"],
        blockExplorerUrls: ["https://basescan.org"],
      }],
    });
  }
}

export async function switchToEthereum() {
  if (!window.ethereum) throw new Error("No wallet detected.");
  await window.ethereum.request({ method: "wallet_switchEthereumChain", params: [{ chainId: "0x1" }] });
}

export function friendlyError(error: unknown) {
  if (error instanceof Error) {
    if (error.message.includes("User rejected") || error.message.includes("rejected the request")) {
      return "Transaction cancelled on the wallet or Ledger.";
    }
    if (error.message.includes("SlippageExceeded")) return "The burn price moved above your maximum. Refresh and try again.";
    if (error.message.includes("SoldOut")) return "Hardware is sold out. No tokens were burned.";
    if (error.message.includes("EnforcedPause")) return "Hardware redemptions are paused. No tokens were burned.";
    if (error.message.includes("insufficient funds")) return "This wallet does not have enough ETH for gas.";
    return error.message.split("\n")[0];
  }
  return "Something went wrong. Please try again.";
}
